import { httpClient } from "@/shared/http/httpClient";
import {
    ProjectionHealth,
    LagDistribution,
    DLQDepth,
    DLQEventsOutput,
    DriftReportDoc,
    ReconcileSummary,
} from "@/features/observability/types/projection.types";

const API_PATH = "/api/v1/analytics/projections";

const fetchHealth = (): Promise<ProjectionHealth> =>
    httpClient.getJson<ProjectionHealth>(`${API_PATH}/health`);

const fetchLag = (): Promise<LagDistribution> =>
    httpClient.getJson<LagDistribution>(`${API_PATH}/lag?granularity=hour`);

// Depth + byErrorCode/byOperationType breakdown — used to diagnose what is
// dominating the pending failures before re-driving.
const fetchDLQ = (): Promise<DLQDepth> =>
    httpClient.getJson<DLQDepth>(`${API_PATH}/dlq`);

// onlyPending: the "Cola de fallos" table must match the health DLQ depth,
// which counts only not-yet-redriven failures.
const fetchDLQEvents = (): Promise<DLQEventsOutput> =>
    httpClient.getJson<DLQEventsOutput>(
        `${API_PATH}/dlq/events?limit=20&onlyPending=true`
    );

const fetchDrift = (): Promise<DriftReportDoc[]> =>
    httpClient.getJson<DriftReportDoc[]>(`${API_PATH}/drift?limit=50`);

const reconcileDLQ = (limit: number): Promise<ReconcileSummary> =>
    httpClient.postJson<ReconcileSummary>(`${API_PATH}/dlq/reconcile`, { limit });

export const projectionMonitoringApi = {
    fetchHealth,
    fetchLag,
    fetchDLQ,
    fetchDLQEvents,
    fetchDrift,
    reconcileDLQ,
};
